/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  $('.product-upsell__content2 select').change(function(){
    let selVal = $(this).val();
    let setPrice = $(this).find(':selected').attr('data-price');
    let setImg = $(this).find(':selected').attr('data-img');
    $(this).closest('.product-upsell').find('.product-upsell__content--btn p').text(setPrice);
    $(this).closest('.product-upsell').find('input[name=id]').val(selVal);
    if(setImg !== "") {
      $(this).closest('.product-upsell').find('.product-upsell__image-inner').css("background-image", "url(" + setImg + ")");
    }
  });
  
  
  $('.ms-upsell-holder select').change(function(){
    let selVal = $(this).val();
    let setPrice = $(this).find(':selected').attr('data-price');
    let setImg = $(this).find(':selected').attr('data-img');
    $(this).closest('.product-upsell').find('.new-price').text(setPrice);
    $(this).closest('.product-upsell').find('input[name=id]').val(selVal);
    if(setImg !== "") {
      $(this).closest('.product-upsell').find('.product-upsell__image-inner').css("background-image", "url(" + setImg + ")");
    }
  });
  
  $('.header__desktop__button--col select').change(function(){
    if($(this).attr('data-link') != "") {
      let abc = $('option:selected', this).attr('data-link');
      window.location.href = abc;
    }
  });
  
  $('.drawer-content---col select').change(function(){
    if($(this).attr('data-link') != "") {
      let abc = $('option:selected', this).attr('data-link');
      window.location.href = abc;
    }
  });
  
  $('.drawer-content---col-inner svg').click(function(){
    $('.header__mobile__hamburger').trigger('click');
  });
  
 $("#widthTempOption").html($('#resizingSelectTag option:selected').text());
 $('#resizingSelectTag').width($("#selectTagWidth").width());  
  
  $('.ms-404-btn-2 a').click(function(e){
    e.preventDefault();
    $('.ms-404 .search-outer').slideToggle();
  });
  
  
  $('#subscribe-modal-popups').click(function(e){
    e.preventDefault();
    localStorage.setItem('msPopupClicked', "ReadyHidden");
    let tmpName = $('#tmpName').val();
    let msFirstName = tmpName.split(' ').slice(0, -1).join(' ');
    let msLastName = tmpName.split(' ').slice(-1).join(' ');
    if(msFirstName == "") {
     msFirstName = msLastName; 
    }
    
    $('#msFirstName').val(msFirstName);
    $('#msLastName').val(msLastName);
    
    let tmpMonth = $('#Birthday_month').val();
    let tmpDay = $('#Birthday_day').val();
    let tmpYear = $('#Birthday_year').val();
    
    $('#Birthday').val(tmpMonth+'/'+tmpDay+"/"+tmpYear);
    
    $('.ms-popup-form').submit();
  });	
  
})();
